import { LANGUAGES, type Language } from "../../config/routes.js";

// Framer Locales serves non-default locales under a path prefix (e.g. `/fr`,
// `/fr/pricing`). The default locale (English) has no prefix.
export const getLang = (): Language => {
  const path = window.location.pathname;
  const matched = LANGUAGES.find(
    (lang) => lang !== "en" && (path === `/${lang}` || path.startsWith(`/${lang}/`))
  );
  return matched ?? "en";
};
